import ApiClient from '../Clients/ApiClient';

const basePaths = {
    public: '/lf-data/api/v1',
    protected: '/lf-data-authenticated/api/v1',
    authenticated: '/lf-data-authenticated/api/v1' //Todo: Changed this back to v1 because of new Api
};

const dataEndpoints = {
    // public
    quickInsuranceQuote: (insuranceGroup, birthDate) =>
        `/lf-data/api/v1/insurancequotes?insurancegroup=${insuranceGroup}&birthDate=${birthDate}`,

    homeInsuranceQuotes: (zipCode, birthDate) =>
        `/lf-data/api/v1/homeinsurancequotes?zipCode=${zipCode}&birthDate=${birthDate}`,

    animalInsuranceQuotes: function (animalType, breedId, birthdate, gender, previouslyInsured, zipCode, includeLifeInsuranceQuote, lifeInsuranceValue) {
        return (`/lf-data/api/v1/animalinsurancequotes?animalType=${animalType}&animalBreedId=${breedId}` +
            (birthdate !== null ? `&birthDate=${birthdate}` : '') +
            (gender ? `&gender=${gender}` : '') +
            (typeof previouslyInsured !== 'undefined' ? `&hasBeenPreviouslyInsured=${previouslyInsured}` : '') +
            `&zipCode=${zipCode}` +
            (includeLifeInsuranceQuote !== null ? `&includeLifeInsuranceQuote=${includeLifeInsuranceQuote}` : '') +
            (lifeInsuranceValue !== null ? `&lifeInsuranceValue=${lifeInsuranceValue}` : ''))
    },

    animalBreeds: (animalType) =>
        `/lf-data/api/v1/animalbreeds?animalType=${animalType}`,

    categorizedFAQData: (selectedCategory) =>
        `/api/v1/faq/questions?selectedCategories=${selectedCategory}`,

    // protected (member only)

    customerInfo: `/lf-data-authenticated/api/v1/customer`,
    customerAnimals: `/lf-data-authenticated/api/v1/memberanimals`,
    customerChildren: `/lf-data-authenticated/api/v1/memberchildren`,
    travelCertificate: `/lf-data-authenticated/api/v1/travelcertificate`,
    mailTravelCertificate: `/lf-data-authenticated/api/v1/travelcertificate/mail`,
    possessions: `/lf-data-authenticated/api/v1/possessions`,
    possessionStatus: (groups) =>
        `/lf-data-authenticated/api/v1/possession/status?InsuranceGroup=`
        + groups.join('&InsuranceGroup='),
    insurances: `/lf-data-authenticated/api/v1/insurances`,
    purchase: `/lf-data-authenticated/api/v1/purchase`,
    preregistrations: `/lf-data-authenticated/api/v1/preregistrations`,
    paymentMethod: `/lf-data-authenticated/api/v1/paymentmethod`,
    saveHealthdeclaration: `/lf-data-authenticated/api/v1/healthdeclaration`,
    pensionGuidanceForm: `/lf-data-authenticated/api/v1/pensionguidanceform`,
    student: `/lf-data-authenticated/api/v1/student`,
    extension: `/lf-data-authenticated/api/v1/extendinsurance`,
    extensionAutomatic: `/lf-data-authenticated/api/v1/extendinsurance/automaticpayment`,
    healthdeclaration: (insuranceName, objId) =>
        `/lf-data-authenticated/api/v1/healthdeclaration?insuranceName=${insuranceName}` + (objId ? `&insuranceObjectId=${objId}` : ''),

    quote: (insuranceName, values) =>
        `/lf-data-authenticated/api/v1/quote?insuranceName=${insuranceName}` +
        `${Object.keys(values).map(k => `&${k}=${values[k]}`).join('')}`,

    quotes: (zipCode, purchaseDate = null) =>
        `/lf-data-authenticated/api/v1/quotes?zipCode=${zipCode}` + (purchaseDate ? `&purchaseDate=${purchaseDate}` : ''),

    insuranceObjectQuote: (insuranceName, insuranceObjectId, insuranceValue) =>
        `/lf-data-authenticated/api/v1/insuranceobjectquote?insuranceName=${insuranceName}` +
        `&insuranceValue=${insuranceValue}&insuranceObjectId=${insuranceObjectId}`,



    achievements: `/lf-data-authenticated/api/v1/achievements`,
    newAchievements: `/lf-data-authenticated/api/v1/achievements/new`,

    coInsuredForm: `/lf-data-authenticated/api/v1/customerinfo/coinsured`,

    announcements: `/lf-data-authenticated/api/v1/achievements/notifications`,
    wizardQuestions: `/lf-data-authenticated/api/v1/customerknowledgeform`,

    // calls to api, v2

    possessionsData: `/lf-data-authenticated/api/v1/possessions`,
    basicCoverageData: `/lf-data-authenticated/api/v1/basic-coverage`,
    managedPensionQuestions: `/lf-data-authenticated/api/v1/managedpensioninsurances/questions`,
    managedPensionApplications: `/lf-data-authenticated/api/v1/managedpensioninsurances/applications`,
    preregistrationSummary: `/lf-data-authenticated/api/v1/preregistrationsummary`,

    managedPensionApplicationStatus: (applicationId) =>
        `/lf-data-authenticated/api/v1/managedpensioninsurances/applications/${applicationId}/status`,

    managedPensionApplicationSignStatus: (applicationId) =>
        `${basePaths.authenticated}/managedpensioninsurances/applications/${applicationId}/sign`,

    managedPensionSigningReference: ( applicationId, signingRef ) =>
        `${basePaths.authenticated}/managedpensioninsurances/applications/${applicationId}/sign/${signingRef}`
};

let instance = null;
export default class LfDataService {
    constructor() {
        if (!instance) {
            this.client = new ApiClient({ baseUrl: '' });
            instance = this;
        }

        return instance;
    }

    // url getters

    get generatedTravelCertificateUrl() {
        return dataEndpoints.travelCertificate;
    }

    // public calls

    quickInsuranceQuote(insuranceGroup, birthDate) {
        return this.client.get(dataEndpoints.quickInsuranceQuote(insuranceGroup, birthDate));
    }

    homeInsuranceQuotes(zipCode, birthDate) {
        return this.client.get(dataEndpoints.homeInsuranceQuotes(zipCode, birthDate));
    }

    animalBreeds(type) {
        return this.client.get(dataEndpoints.animalBreeds(type));
    }

    getAnimalInsuranceQuotes(animalType, breedId, birthdate = null, gender = null, previouslyInsured = null,
        zipCode, includeLifeInsuranceQuote = null, lifeInsuranceValue = null) {
            return this.client.get(
                dataEndpoints.animalInsuranceQuotes(animalType, breedId, birthdate, gender,
                    previouslyInsured, zipCode, includeLifeInsuranceQuote, lifeInsuranceValue)
            );
    }

    getCategorizedFAQData(selectedCategory) {
        return this.client.get(dataEndpoints.categorizedFAQData(selectedCategory));
    }

    // protected calls

    insurances() {
        return this.client.get(dataEndpoints.insurances);
    }

    customerInfo() {
        return this.client.get(dataEndpoints.customerInfo);
    }

    customerAnimals() {
        return this.client.get(dataEndpoints.customerAnimals);
    }
    customerChildren() {
        return this.client.get(dataEndpoints.customerChildren);
    }

    paymentMethod() {
        return this.client.get(dataEndpoints.paymentMethod);
    }

    updatePaymentMethod(bankcode, accountnumber) {
        const postData = {
            accountnumber: parseInt(accountnumber, 10),
            bankcode: parseInt(bankcode, 10)
        };

        return this.client.post(dataEndpoints.paymentMethod, postData);
    }

    updateEmail(data) {
        return this.client.post(dataEndpoints.customerInfo, data);
    }

    updateProfile(data) {
        return this.client.post(dataEndpoints.customerInfo, data);
    }

    updateCustomerChildren(data) {
        return this.client.put(dataEndpoints.customerChildren, data);
    }

    extendStudentInsuranceAutomatic(insuranceName, accountnumber, bankcode, IsFullyAbleToWork, PurchaseTermsApproved) {
        const postData = {
            insurancename: insuranceName,
            accountnumber: parseInt(accountnumber, 10),
            bankcode: parseInt(bankcode, 10),
            IsFullyAbleToWork: !!IsFullyAbleToWork,
            PurchaseTermsApproved: !!PurchaseTermsApproved
        };

        return this.client.post(dataEndpoints.extensionAutomatic, postData);
    }

    extendStudentInsurance(insuranceName, IsFullyAbleToWork, PurchaseTermsApproved) {
        const postData = {
            insurancename: insuranceName,
            IsFullyAbleToWork: !!IsFullyAbleToWork,
            PurchaseTermsApproved: !!PurchaseTermsApproved
        };

        return this.client.post(dataEndpoints.extension, postData);
    }

    mailTravelCertificate() {
        return this.client.get(dataEndpoints.mailTravelCertificate);
    }

    possessions() {
        return this.client.get(dataEndpoints.possessions);
    }

    possessionStatus(groups) {
        return this.client.get(dataEndpoints.possessionStatus(groups));
    }

    quote(insuranceName, values) {
        return this.client.get(dataEndpoints.quote(insuranceName, values));
    }

    quotes(zipCode) {
        return this.client.get(dataEndpoints.quotes(zipCode));
    }

    insuranceObjectQuote(insuranceName, insuranceObjectId, insuranceValue) {
        return this.client.get(dataEndpoints.insuranceObjectQuote(insuranceName, insuranceObjectId, insuranceValue));
    }

    preregistrations() {
        return this.client.get(dataEndpoints.preregistrations);
    }

    healthDeclaration(insuranceName, objId) {
        return this.client.get(dataEndpoints.healthdeclaration(insuranceName, objId));
    }

    saveHealthDeclaration(data) {
        return this.client.post(dataEndpoints.saveHealthdeclaration, data);
    }

    validateInsurancePurchaseData(insuranceData) {
        let data = window.__bazStore.getState().insurancePageData;

        return this.client.post(dataEndpoints.purchase, {
            onlyValidate: true,
            insurances: [{
                personId: data.customerInfo.personId,
                streetAddress: data.customerInfo.streetAddress,
                address2: data.customerInfo.address2,
                zipCode: data.customerInfo.zipCode,

                ...insuranceData
            }]
        });
    }

    purchase(orders, onlyValidate = false) {
        let data = window.__bazStore.getState().insurancePageData;

        const insurances = orders.map(insuranceOrder => ({
            personId: data.customerInfo.personId,
            streetAddress: data.customerInfo.streetAddress,
            address2: data.customerInfo.address2,
            zipCode: data.customerInfo.zipCode,

            ...insuranceOrder
        }));

        return this.client.post(dataEndpoints.purchase, {
            onlyValidate,
            insurances
        });
    }

    pensionGuidanceForm() {
        return this.client.get(dataEndpoints.pensionGuidanceForm);
    }

    submitPensionGuidance(data) {
        return this.client.post(dataEndpoints.pensionGuidanceForm, data);
    }

    submitCoInsured(data) {
        return this.client.post(dataEndpoints.coInsuredForm, data);
    }

    getAchievements() {
        return this.client.get(dataEndpoints.achievements);
    }

    getNewAchievements() {
        return this.client.get(dataEndpoints.newAchievements);
    }

    submitViewedAchievements() {
        return this.client.post(dataEndpoints.newAchievements, {});
    }

    getAnnouncements() {
        return this.client.get(dataEndpoints.announcements);
    }

    viewedAnnouncements() {
        return this.client.post(dataEndpoints.announcements, {});
    }

    getWizardQuestions() {
        return this.client.get(dataEndpoints.wizardQuestions);
    }

    submitWizardForm(data) {
       return this.client.post(dataEndpoints.wizardQuestions, data);
    }

    // protected / authenticated calls to api, v2

    getPossessionsData() {
        return this.client.get(dataEndpoints.possessionsData);
    }

    getBasicCoverageData() {
        return this.client.get(dataEndpoints.basicCoverageData);
    }

    getManagedPensionQuestions() {
        return this.client.get(dataEndpoints.managedPensionQuestions);
    }

    getPreregistrationSummary() {
        return this.client.get(dataEndpoints.preregistrationSummary);
    }

    submitPensionWizardForm(data) {
        return this.client.post(dataEndpoints.managedPensionApplications, data);
    }

    // Check application status at Futur - can application be signed with bankId? GET /status
    getManagedPensionApplicationSignatureStatus(data) {
        return this.client.get(dataEndpoints.managedPensionApplicationStatus(data.appId), {});
    }

    // POST to /sign to get autoStartToken and signingReference
    startManagedPensionApplicationSigning(data) {
        return this.client.post(dataEndpoints.managedPensionApplicationSignStatus(data.appId), {});
    }

    // GET to /sign: Check application status at BankId
    getManagedPensionApplicationBankIDStatus(data) {
        return this.client.get(dataEndpoints.managedPensionApplicationSignStatus(data.appId));
    }

    // Get ongoing status of BankID signing
    getManagedPensionBankIDCurrentStatus(data) {
        return this.client.get(dataEndpoints.managedPensionSigningReference(data.appId, data.signingRef));
    }
}
